export default __webpack_public_path__ + "static/media/currency.4e00cf17.svg";